export { default as LoyaltyRewardsListWidget } from './loyalty-rewards-list-widget';
